/**
 * Helper functions to get an url with the base href path
 * @param url The path of the absolute url
 * @returns URL object with absolute url
 */
export function getAbsoluteUrl(url = '') {
    return new URL(url, document.baseURI).href;
}
